//basic
import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../../functions/api';

//custom components
// import CustomInput from '../../../components/basic/input';
import CustomButton from '../../../components/basic/CustomButton';
// import CustomAvatar from '../../../components/basic/customAvatar';
// import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch';

//material-ui
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Button,
    CircularProgress,
    Grid,
    createMuiTheme,
    MuiThemeProvider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';

//style
import './ChangeOrderStatus.scss';

//other libraries
import moment from 'moment'

const theme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiFormControl: {
            root: {
                width: "100%",
            }
        },
        MuiFormLabel: {
            root: {
                color: "rgba(0, 0, 0, 0.54) !important"
            },
            focused: {
                color: "rgba(0, 0, 0, 0.54) !important"
            }
        },
        MuiInput: {
            underline: {
                "&:after": {
                    borderBottomColor: "rgba(0, 0, 0, 0.54) !important"
                }
            },
            disabled: {
                color: "black",
                "&:before": {
                    borderBottomStyle: 'solid !important',
                    borderBottomColor: "black"
                }
            }
        },
        MuiTableCell: {
            root: {
                padding: "10px 5px"
            },
            head: {
                padding: "10px 5px"
            }
        }
    }
})


@inject('translate')
@inject('internal')
@observer
export default class ChangeOrderStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            loadingBtn: false,
            loading: true,
            data: {}
        }
    }

    componentDidMount () {
        // this.setState({data: this.props.data})
        this.loadDetailOrder()
    }

    loadDetailOrder = async() => {

        let idOrder = this.props.data.id
        let load_data = await api({
            url: `customer-orders/${idOrder}`,
            method: 'GET',
            authorization: this.props.internal.user.access_token,

        })

        if(load_data.success === true) {
            this.setState({data: load_data.data.data})
        }

        this.setState({loading: false})
    }

    formatMoney = (data) => {
        const formatter = new Intl.NumberFormat('sk-SK', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2
        })
        return formatter.format(data)
    }

    handleChangeStatus = (val) => {
        let data = this.state.data
        
        data.customer_order_status_id = Number(val.target.value)

        this.setState({data: data})
    }

    updateStatus = async() => {
        this.setState({loadingBtn: true})
        let id = this.props.data.id
        let update_data = await api({
            method: 'PATCH',
            url: `customer-orders/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                customer_order_status_id: this.state.data.customer_order_status_id
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.setState({data: update_data.data.data})
            this.props.onClose(true)
        }

        this.setState({loadingBtn: false})
    }

    
    render() {
        let statuses = toJS(this.props.internal.dataForTable.filter.customer_order_status_id[0].items)
        return (
            <MuiThemeProvider theme={theme}>
            <Dialog
                open={this.props.open}
                onClose={() => this.props.onClose(false)}
                aria-labelledby="form-dialog-title"
                classes={{
                    root: "addEditFixedSetDialog-root",
                    paper: "addEditFixedSetDialog-paper"
                }}
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                {this.state.loading
                ?
                <div style={{minHeight: "100px"}}>
                    <CircularProgress className={'circular-progress'} />
                </div>
                :
                <DialogContent classes={{root: "updateCustomer"}}>
                    <Grid container spacing={8}>
                        
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <span>Objednávka #{this.state.data.variable_symbol}</span>
                                </Grid>
                                <Grid item xs={12}>
                                <div className={'tableCustomerOrderDetail'}>
                                <Table >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{minWidth: "120px"}}>{this.props.translate.i18n.MODULES["CUSTOMERS-ORDERS"].ORDER_STATUS}</TableCell>
                                            <TableCell style={{minWidth: "120px"}}>{this.props.translate.i18n.MODULES["CUSTOMERS-ORDERS"].ORDER_STATUS_UPDATED_BY}</TableCell>
                                            <TableCell style={{minWidth: "100px"}}>{this.props.translate.i18n.MODULES["CUSTOMERS-ORDERS"].ORDER_STATUS_UPDATED_AT}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.data.customer_order_status_history && this.state.data.customer_order_status_history.map((item, index)=> {
                                            return (
                                                <TableRow key={index}>
                                                    {/* <TableCell className={'first-cell'} style={{width: '50px',paddingLeft: 0, paddingRight: 0}}>
                                                        <CustomIconButton
                                                            id={item}
                                                            label="More"
                                                            dropdownMenu
                                                            items={this.detail}
                                                            module={'/customers-orders'}
                                                            aboutItem={item}
                                                            data={item}
                                                        >
                                                            <Icon path={mdiDotsVertical} size={1} />
                                                        </CustomIconButton>
                                                    </TableCell>
                                                    <TableCell>
                                                        <InputBase type={'number'} defaultValue={item.quantity} onChange={(val) => this.handleChangeQuantity(item, val)}/>
                                                    </TableCell> */}
                                                    <TableCell >{item.status}</TableCell>
                                                    <TableCell >{item.user && item.user !== null ? item.user.username : 'N/A'}</TableCell>
                                                    <TableCell >{moment(item.created_at).format('HH:mm DD.MM.YYYY')}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        
                                </Grid>
                                <Grid item xs={12} sm={6} >
                                    
                                    <FormControl className='changeStatus'>
                                    <InputLabel htmlFor="filterPaymentStatus" >{this.props.translate.i18n.MODULES["CUSTOMERS-ORDERS"].NEW_STATUS}</InputLabel>
                                        <Select
                                            // text={this.props.translate.i18n.MODULES["CUSTOMERS-ORDERS"].CHANGE_STATUS}
                                            value={this.state.data.customer_order_status_id}
                                            onChange={(val) => this.handleChangeStatus(val)}
                                            inputProps={{
                                                name: 'filterPaymentStatus',
                                                id: 'filterPaymentStatus',
                                            }}
                                        >
                                            {statuses.map((status, index) => {
                                                return (
                                                    <MenuItem key={index} value={status.id} className={'popup-menu'} >{status.name}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                
                            </Grid>
                        
                        </Grid>
                    </Grid>
                    
                </DialogContent>
                }
                <DialogActions>
                    <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.updateStatus}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>
            </Dialog>
            </MuiThemeProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/CustomersOrders/ChangeOrderStatus/ChangeOrderStatus.jsx